export default __webpack_public_path__ + "181704204bf7da2ee32474c9f262f1cd.png";